/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from "react"
import { Flex, Box } from "theme-ui"
import _ from "lodash"
import graphql from "babel-plugin-relay/macro"
import {
  useMutation
} from "react-relay"
import styled from "@emotion/styled"

import WebchatPreview from "../../components/WebchatPreview/WebchatPreview"
import ToggleField from "../Radiate/ToggleField/ToggleField"
import NewBoxButton from "../Radiate/NewBoxButton/NewBoxButton"
import IceBreakerAndPersistentMenuField from "../../components/IceBreakerAndPersistentMenuField/IceBreakerAndPersistentMenuField"
import Tab from "../../components/Radiate/Tab/Tab"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import * as Styles from "./IceBreakersAndPersistentMenuStyles"
import LocalisedSelectionList from "../LocalisedSelectionList/LocalisedSelectionList"
import { randomString } from "../util"
import TextField from "../Radiate/TextField/TextField"


const IceBreakersAndPersistentMenuMutation = graphql`
  mutation IceBreakersAndPersistentMenu_updateBusinessMutation ($input: UpdateBusinessInput!) {
    updateBusiness(input: $input) {
      business {
        id
        businessId
        localeGroups {
          id
          name
          locales
          default
        }
        profile {
          name
          legalName
          about
          phones {
            number
            alias
          }
          addresses {
            line1
            line2
            city
            state
            country
            alias
          }
          websites {
            url
            alias
          }
          emails {
            email
            alias
          }
          logoUrl
          botAgentImageUrl
        }
        chatConfiguration {
          themeColor
          customCss
          showAgentProfile
          localised {
            localeId
            persistentMenu {
              buttons
              enable
            }
            iceBreakers {
              ctas
              enable
            }
            inputPlaceholder
          }
        }
      }
    }
  }
`

const StyledTextField = styled(TextField)`
  margin-right: 16px;
  .text-field-label {
    color: ${p => p.theme.gray7};
  }
  &:focus-within {
    .text-field-label {
      color: ${p => p.theme.themeColor};
    }
  }
`

const IceBreakersAndPersistentMenu = ({
  info
}) => {
  const [selectedLg, setSelectedLg] = useState("")
  const [selectedType, setSelectedType] = useState("iceBreakers")
  const [businessInfo, setBusinessInfo] = useState(info)
  const [modInfo, setModInfo] = useState(null)
  const [multilingual, setMultilingual] = useState(info?.chatConfiguration?.localised?.length > 1 ? true : false)
  const [commit, isInFlight] = useMutation(
    IceBreakersAndPersistentMenuMutation
  )

  useEffect(() => {
    if (info) {
      setSelectedLg(info?.chatConfiguration?.localised[0]?.localeId)
    }
  }, [])

  useEffect(() => {
    const modInfo = _.cloneDeep(info)
    const newLocaleGroupId = randomString(8)
    if (!modInfo?.chatConfiguration?.localised?.length) {
      const modLocalised = [
        {
          localeId: newLocaleGroupId,
          persistentMenu: {
            buttons: [],
            enable: true
          },
          iceBreakers: {
            ctas: [],
            enable: true
          },
          inputPlaceholder: "Send a message..."
        }
      ]
      const newLocaleGroup = {
        id: newLocaleGroupId,
        name: "Default",
        locales: [],
        default: true,
      }
      modInfo.chatConfiguration.localised = modLocalised
      modInfo.localeGroups = [newLocaleGroup]
      setBusinessInfo(modInfo)
      setModInfo(modInfo)
    } else {
      setModInfo(info)
      setBusinessInfo(info)
    }
  }, [JSON.stringify(info)])

  const selected = (businessInfo?.chatConfiguration?.localised || []).find(l => l.localeId === (selectedLg || "default"))
  const selectedIndex = (businessInfo?.chatConfiguration?.localised || []).findIndex(l => l.localeId === (selectedLg || "default"))
  const iceBreakersContent = () => {
    return (
      <Styles.SettingsContent>
        <Flex my={2} sx={{ alignItems: "center", justifyContent: "flex-end", color: "#626262" }}>
          <ToggleField
            label="Enable"
            value={selected?.iceBreakers?.enable}
            onChange={(value) => {
              const modLocalised = [
                ...businessInfo?.chatConfiguration?.localised.slice(0, selectedIndex),
                {
                  localeId: selected.localeId,
                  persistentMenu: selected.persistentMenu,
                  iceBreakers: {
                    enable: value,
                    ctas: selected?.iceBreakers?.ctas
                  },
                  inputPlaceholder: selected?.inputPlaceholder,
                },
                ...businessInfo?.chatConfiguration?.localised.slice(selectedIndex + 1),
              ]
              const modBusinessInfo = _.cloneDeep(businessInfo)
              modBusinessInfo.chatConfiguration.localised = modLocalised
              setBusinessInfo(modBusinessInfo)
            }}
          />
        </Flex>

        {selected?.iceBreakers?.ctas?.length > 0 && selected?.iceBreakers?.ctas.map((action, i) => {
          return (
            <IceBreakerAndPersistentMenuField
              type="ib"
              key={i}
              index={i}
              action={action}
              onChange={(value) => {
                const selectedCtas = [
                  ...selected?.iceBreakers?.ctas.slice(0, i),
                  value,
                  ...selected?.iceBreakers?.ctas.slice(i + 1)
                ]
                const modLocalised = [
                  ...businessInfo?.chatConfiguration?.localised.slice(0, selectedIndex),
                  {
                    localeId: selected.localeId,
                    persistentMenu: selected.persistentMenu,
                    iceBreakers: {
                      ctas: selectedCtas,
                      enable: selected?.iceBreakers?.enable
                    },
                    inputPlaceholder: selected?.inputPlaceholder,
                  },
                  ...businessInfo?.chatConfiguration?.localised.slice(selectedIndex + 1),
                ]
                const modBusinessInfo = _.cloneDeep(businessInfo)
                modBusinessInfo.chatConfiguration.localised = modLocalised
                setBusinessInfo(modBusinessInfo)
              }}
              onRemove={(index) => {
                const selectedCtas = [
                  ...selected?.iceBreakers?.ctas.slice(0, index),
                  ...selected?.iceBreakers?.ctas.slice(index + 1)
                ]
                const modLocalised = [
                  ...businessInfo?.chatConfiguration?.localised.slice(0, selectedIndex),
                  {
                    localeId: selected.localeId,
                    persistentMenu: selected.persistentMenu,
                    iceBreakers: {
                      ctas: selectedCtas,
                      enable: selected?.iceBreakers?.enable
                    },
                    inputPlaceholder: selected?.inputPlaceholder,
                  },
                  ...businessInfo?.chatConfiguration?.localised.slice(selectedIndex + 1),
                ]
                const modBusinessInfo = _.cloneDeep(businessInfo)
                modBusinessInfo.chatConfiguration.localised = modLocalised
                setBusinessInfo(modBusinessInfo)
              }}
            />
          )
        })}
        <Styles.AddQuestionButton
          disabled={selected?.iceBreakers?.ctas?.length >= 5}
          onClick={() => {
            const ctas = selected?.iceBreakers?.ctas || []
            let selectedCtas = [
              ...ctas,
              {
                question: "",
                payload: ""
              }
            ]
            const modLocalised = [
              ...businessInfo?.chatConfiguration?.localised.slice(0, selectedIndex),
              {
                localeId: selected.localeId,
                name: selected?.name || "default",
                persistentMenu: selected.persistentMenu,
                iceBreakers: {
                  ctas: selectedCtas,
                  enable: true
                },
                inputPlaceholder: selected?.inputPlaceholder,
              },
              ...businessInfo?.chatConfiguration?.localised.slice(selectedIndex + 1),
            ]
            const modBusinessInfo = _.cloneDeep(businessInfo)
            modBusinessInfo.chatConfiguration.localised = modLocalised
            setBusinessInfo(modBusinessInfo)
          }}
        >
          <FontAwesomeIcon
            icon={faPlus}
            className="icon"
          />
          Add Question
        </Styles.AddQuestionButton>
      </Styles.SettingsContent>
    )
  }

  const persistentMenuContent = () => {
    return (
      <>
        <Flex my={2} sx={{ alignItems: "center", justifyContent: "flex-end", color: "#626262" }}>
          <ToggleField
            label="Enable"
            value={selected?.persistentMenu?.enable}
            onChange={(value) => {
              const modLocalised = [
                ...businessInfo?.chatConfiguration?.localised.slice(0, selectedIndex),
                {
                  localeId: selected.localeId,
                  persistentMenu: {
                    enable: value,
                    buttons: selected?.persistentMenu?.buttons
                  },
                  iceBreakers: selected.iceBreakers,
                  inputPlaceholder: selected?.inputPlaceholder,
                },
                ...businessInfo?.chatConfiguration?.localised.slice(selectedIndex + 1),
              ]
              const modBusinessInfo = _.cloneDeep(businessInfo)
              modBusinessInfo.chatConfiguration.localised = modLocalised
              setBusinessInfo(modBusinessInfo)
            }}
          />
        </Flex>
        {selected?.persistentMenu?.buttons?.length > 0 && selected?.persistentMenu?.buttons.map((action, i) => {
          return (
            <IceBreakerAndPersistentMenuField
              key={i}
              type="pm"
              index={i}
              action={action}
              onChange={(value) => {
                const selectedButtons = [
                  ...selected?.persistentMenu?.buttons.slice(0, i),
                  value,
                  ...selected?.persistentMenu?.buttons.slice(i + 1)
                ]
                const modLocalised = [
                  ...businessInfo?.chatConfiguration?.localised.slice(0, selectedIndex),
                  {
                    localeId: selected.localeId,
                    iceBreakers: selected.iceBreakers,
                    inputPlaceholder: selected?.inputPlaceholder,
                    persistentMenu: {
                      buttons: selectedButtons,
                      enable: true
                    }
                  },
                  ...businessInfo?.chatConfiguration?.localised.slice(selectedIndex + 1),
                ]
                const modBusinessInfo = _.cloneDeep(businessInfo)
                modBusinessInfo.chatConfiguration.localised = modLocalised
                setBusinessInfo(modBusinessInfo)
              }}
              onRemove={(index) => {
                const selectedButtons = [
                  ...selected?.persistentMenu?.buttons.slice(0, index),
                  ...selected?.persistentMenu?.buttons.slice(index + 1)
                ]
                const modLocalised = [
                  ...businessInfo?.chatConfiguration?.localised.slice(0, selectedIndex),
                  {
                    localeId: selected.localeId,
                    iceBreakers: selected.iceBreakers,
                    inputPlaceholder: selected?.inputPlaceholder,
                    persistentMenu: {
                      buttons: selectedButtons,
                      enable: true
                    }
                  },
                  ...businessInfo?.chatConfiguration?.localised.slice(selectedIndex + 1),
                ]
                const modBusinessInfo = _.cloneDeep(businessInfo)
                modBusinessInfo.chatConfiguration.localised = modLocalised
                setBusinessInfo(modBusinessInfo)
              }}
            />
          )
        })}
        <Styles.AddQuestionButton
          onClick={() => {
            const buttons = selected?.persistentMenu?.buttons || []
            const selectedButtons = [
              ...buttons,
              {
                title: "",
                payload: "",
                type: "postback",
                url: ""
              }
            ]
            const modLocalised = [
              ...businessInfo?.chatConfiguration?.localised.slice(0, selectedIndex),
              {
                localeId: selected.localeId,
                name: selected?.name,
                iceBreakers: selected.iceBreakers,
                inputPlaceholder: selected?.inputPlaceholder,
                persistentMenu: {
                  buttons: selectedButtons,
                  enable: true,
                }
              },
              ...businessInfo?.chatConfiguration?.localised.slice(selectedIndex + 1),
            ]
            const modBusinessInfo = _.cloneDeep(businessInfo)
            modBusinessInfo.chatConfiguration.localised = modLocalised
            setBusinessInfo(modBusinessInfo)
          }}
        >
          <FontAwesomeIcon
            icon={faPlus}
            className="icon"
          />
          Add Button
        </Styles.AddQuestionButton>
      </>
    )
  }

  const inputPlaceholderMenuContent = () => {
    return (
      <Flex my={2} sx={{ flexDirection: "column", alignItems: "stretch", color: "#626262" }}>
        <StyledTextField
          useInput
          label="Input Placeholder"
          value={selected?.inputPlaceholder}
          placeholder="Send a message..."
          borderStyle
          onChange={(e) => {
            const modLocalised = [
              ...businessInfo?.chatConfiguration?.localised.slice(0, selectedIndex),
              {
                localeId: selected.localeId,
                persistentMenu: {
                  enable: selected?.persistentMenu?.enable,
                  buttons: selected?.persistentMenu?.buttons
                },
                iceBreakers: selected.iceBreakers,
                inputPlaceholder: e.target.value,
              },
              ...businessInfo?.chatConfiguration?.localised.slice(selectedIndex + 1),
            ]
            const modBusinessInfo = _.cloneDeep(businessInfo)
            modBusinessInfo.chatConfiguration.localised = modLocalised
            setBusinessInfo(modBusinessInfo)
          }}
        />
      </Flex>
    )
  }

  const inputPlaceholderContent = () => {
    return (
      <Flex sx={{ flexDirection: "column" }}>
        <StyledTextField
          useInput
          label="Input Placeholder"
          value={selected?.inputPlaceholder}
          placeholder="Send a message..."
          borderStyle
          onChange={(e) => {
            const modLocalised = [
              ...businessInfo?.chatConfiguration?.localised.slice(0, selectedIndex),
              {
                localeId: selected.localeId,
                persistentMenu: {
                  enable: selected?.persistentMenu?.enable,
                  buttons: selected?.persistentMenu?.buttons
                },
                iceBreakers: selected.iceBreakers,
                inputPlaceholder: e.target.value,
              },
              ...businessInfo?.chatConfiguration?.localised.slice(selectedIndex + 1),
            ]
            const modBusinessInfo = _.cloneDeep(businessInfo)
            modBusinessInfo.chatConfiguration.localised = modLocalised
            setBusinessInfo(modBusinessInfo)
          }}
        />
      </Flex>
    )
  }

  const renderContent = () => {
    if (selectedType === "iceBreakers") {
      return iceBreakersContent()
    }
    if (selectedType === "inputPlaceholder") {
      return inputPlaceholderContent()
    }
    return (
      persistentMenuContent()
    )
  }

  return (
    <Flex>
      <Box pr={4} sx={{ flexGrow: 1, height: "608px", width: "calc(100% - 440px)", minWidth: "500px"}}>
        <Flex py={3} sx={{ justifyContent: "space-between", alignItems: "center"}}>
          <ToggleField
            sx={{ marginLeft: "8px" }}
            label="Multilingual"
            value={multilingual}
            onChange={(value) => {
              setMultilingual(value)
              if (value) {
                setSelectedLg(businessInfo?.chatConfiguration.localised[0]?.localeId)
              } else {
                const c = confirm("The ice breakers and persistent menu will be all removed except default. Are you sure you want to switch to single lingual?")
                if (c) {
                  const defaultLg = businessInfo?.localeGroups.find(o => o.default)
                  const onlyDefaultLocalised = businessInfo?.chatConfiguration?.localised.filter((o) => {
                    return o.localeId === defaultLg.id
                  })
                  const modBusinessInfo = _.cloneDeep(businessInfo)
                  modBusinessInfo.chatConfiguration.localised = onlyDefaultLocalised
                  setBusinessInfo(modBusinessInfo)
                }
              }

            }}
          />
          <NewBoxButton
            text="Save"
            primary
            loading={isInFlight}
            disabled={_.isEqual(businessInfo, modInfo)}
            onClick={() => {
              commit({
                variables: {
                  input: {
                    businessId: info?.businessId,
                    localised: businessInfo?.chatConfiguration?.localised,
                    localeGroups: businessInfo?.localeGroups
                  },
                },
                onCompleted: (response, errs) => { },
                onError: (err) => {
                  console.log(err)
                }
              })
            }}
          />
        </Flex>
        
        <Styles.SettingsContainer
          multilingual={multilingual}
        >
          {(businessInfo?.chatConfiguration?.localised?.length > 1 || multilingual) &&
            <LocalisedSelectionList
              info={businessInfo}
              selectedLg={selectedLg}
              selectedType={selectedType}
              onChangeSelectedLg={(value) => {
                setSelectedLg(value)
              }}
              onChangeSelectedType={(value) => {
                setSelectedType(value)
              }}
              onAddLocalised={(values) => {
                let current = businessInfo?.chatConfiguration?.localised || []
                const modLocalised = [
                  ...current,
                  {
                    localeId: values?.value,
                    // name: values.label,
                    persistentMenu: {
                      buttons: [],
                      enable: true
                    },
                    iceBreakers: {
                      ctas: [],
                      enable: true
                    },
                    inputPlaceholder: "Send a message...",
                  }
                ]
                const modBusinessInfo = _.cloneDeep(businessInfo)
                modBusinessInfo.chatConfiguration.localised = modLocalised
                setBusinessInfo(modBusinessInfo)
              }}
              onRemoveLocalised={(value) => {
                const modLocalised = businessInfo?.chatConfiguration?.localised.filter(o => o.localeId !== value)
                const modBusinessInfo = _.cloneDeep(businessInfo)
                modBusinessInfo.chatConfiguration.localised = modLocalised
                setBusinessInfo(modBusinessInfo)
              }}
            />
          }
          <Box sx={{ flexGrow: 1, height: "100%", overflowY: "scroll" }}>
            {multilingual ?
              <>
                {renderContent()}
              </>
              :
              <Tab
                newTheme
                onSelectTab={(toIndex) => {
                  if (toIndex === 0) {
                    setSelectedType("iceBreakers")
                  } else if (toIndex === 1) {
                    setSelectedType("persistentMenu")
                  } else {
                    setSelectedType("inputPlaceholder")
                  }
                }}
                tabs={[
                  {
                    id: "iceBreakers",
                    text: "Ice Breakers",
                    content: iceBreakersContent()
                  },
                  {
                    id: "persistentMenu",
                    text: "Persistent Menu",
                    content: persistentMenuContent()
                  },
                  {
                    id: "inputPlaceholder",
                    text: "Input Placeholder",
                    content: inputPlaceholderMenuContent()
                  }
                ]}
              />
            }
            
          </Box>
        </Styles.SettingsContainer>
      </Box>
      <Box pt={2} sx={{ width: "440px", minWidth: "440px", minHeight: "608px", boxSizing: "border-box" }}>
        <WebchatPreview 
          info={businessInfo} 
          cssString={info?.chatConfiguration?.customCss || ""} 
        />
      </Box>
    </Flex>
  )
}

export default IceBreakersAndPersistentMenu
